module.exports = __webpack_public_path__ + "img/excel.4d0a13c2.svg";